import {Component, OnInit} from '@angular/core';
import {DokumentModels} from 'src/app/models/dokument-models';
import {GlobalModels} from 'src/app/models/global-models';
import {ServiceAppModels} from 'src/app/models/serviceapp-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {DokumentDataService} from 'src/app/services/dokument-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ServiceAppService} from 'src/app/services/service-app.service';
import {UserAuthenticationService} from 'src/app/services/user-authentication.service';
import {faBolt} from '@fortawesome/free-solid-svg-icons';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'app-pics', templateUrl: './pics.component.html', styleUrls: ['./pics.component.scss']
})
export class PicsComponent implements OnInit {
    protected displayedDokuColumns: string[] = ['picSynced', 'pic_art', 'pic_bearbeitet', 'pic_desc', 'pic_name', 'pic_ansprechname', 'pic_creator', 'pic_delete'];
    protected imageObject: BehaviorSubject<ServiceAppModels.ImageSliderElement[]> = new BehaviorSubject([] as ServiceAppModels.ImageSliderElement[]);
    protected currTermin?: ServiceAppModels.SA_Objekt;
    protected employeeID?: number;
    protected readonly faBolt = faBolt;
    protected terminBilder: BehaviorSubject<ServiceAppModels.TerminBildListElement[]> = new BehaviorSubject([] as ServiceAppModels.TerminBildListElement[]);
    private terminDBDocuments: ServiceAppModels.SA_DocumentAssignment[] = []; // Aus Stammdaten via Webservice
    private terminIndexedDBPictures: ServiceAppModels.SA_BildFile[] = [];

    constructor(private svcSA: ServiceAppService, private svcMessageBox: MessageBoxService, private userAuthService: UserAuthenticationService, private _datumFormatPipe: DatumFormatPipe, private dokuData: DokumentDataService) {
    }

    public ngOnInit(): void {
        this.currTermin = this.svcSA.getTermin();

        this.loadImages();
        const u = this.userAuthService.getCurrentAuthenticatedUser();
        this.employeeID = u?.employeeID;
    }

    protected async saveDescription(element: ServiceAppModels.TerminBildListElement) {
        /* Quell-Array Anpassen */
        const pics = this.terminBilder.getValue();
        let index2 = pics.findIndex(x => x.id == element.id);
        let terminBildListElement = pics[index2];
        terminBildListElement.description = element.description;
        pics[index2] = terminBildListElement;

        this.terminBilder.next(pics);
        /* Indexed-DB Wert anpassen */
        await this.svcSA.updateDBDokumentDescription(element.id, element.description, element.dokumentQuelle);
    }

    protected async saveImage(event: any): Promise<void> {
        if (!this.currTermin) {
            return;
        }
        const files = event.target.files;
        for (const f of files) {
            const file = new Blob([f], {type: f.type});
            const fileName: string = f.name;

            if (file.size === 0) {
                this.svcMessageBox.showError('Das Bild konnte nicht gespeichert werden, da es leer ist.', '!! FEHLER !!');
            } else {
                // Speichert das Bild in der IndexedDB und sendet es an den Webservice
                if (await this.svcSA.addImageToServiceAppLocalStorage(this.currTermin.serviceID, this.currTermin.objectID, fileName, file)) {
                    this.loadImages();
                } else {
                    this.svcMessageBox.showError('Das Foto konnte nicht gespeichert werden.', '!! FEHLER !!');
                }
            }
        }
    }

    protected async deleteImage(element: ServiceAppModels.TerminBildListElement) {
        if (await this.svcMessageBox.askYesNoQuestion('MAIN_APP_DIALOG.DEL_IMG.msg', 'MAIN_APP_DIALOG.DEL_IMG.title', [element.documentName])) {
            if (await this.svcSA.deleteImage(element.id, element.objectID)) {
                this.loadImages();
            } else {
                console.error('Das Foto konnte nicht gelöscht werden.');
                this.svcMessageBox.showError('Das Bild konnte nicht gelöscht werden.', '!! FEHLER !!');
            }
        }
    }

    protected async openPicture(row: any) {
        let docID = row.id;
        // Hier wird der Dateiname anhand der DocumentID ermittelt
        const pics = this.terminBilder.getValue();
        let fileName = pics.filter(doc => doc.id === docID)[0].documentName;

        if (fileName) {
            // Hier die Datei laden
            this.dokuData.getImageFromIndexedDB(docID, fileName);
        }
    }

    protected loadImages() {
        const images: ServiceAppModels.ImageSliderElement[] = [];
        const pics: ServiceAppModels.TerminBildListElement[] = [];
        const imagesLoaded: Promise<void>[] = [];

        // Via Webservice-Stammdaten Dokumente ermitteln
        this.terminDBDocuments = this.svcSA.getDBTerminDokumente().filter(d => d.fK_ServiceID === this.currTermin!.serviceID);
        this.terminDBDocuments.forEach(terminDocument => {
            let document = this.svcSA.getDBObjektDokumente().filter(d => d.documentID === terminDocument.documentID)[0];
            if (document.sA_TransDocType === 9) {

                let kundenAdresse = this.svcSA.getAuftragsAdresse(this.currTermin!.objectID, GlobalModels.AdressTypes.Kunde);
                let kontaktAdresse = this.svcSA.getAuftragsKontaktAdresse(this.currTermin!.objectID, GlobalModels.AdressTypes.Kunde);

                let listElement: ServiceAppModels.TerminBildListElement = {
                    imageFile: 'photo.png',
                    creator: document.createdBy,
                    id: document.documentID,
                    documentName: document.fileName,
                    description: document.description,
                    datum: document.createdDate!,
                    formattedDate: this._datumFormatPipe.transform(document.createdDate),
                    firstName: kundenAdresse?.firstName,
                    lastName: kundenAdresse?.lastName,
                    ansprechVorname: kontaktAdresse?.firstName,
                    ansprechName: kontaktAdresse?.lastName,
                    dokumentQuelle: DokumentModels.DokumentSource.FromWebService,
                    objectID: document.objectID,
                    uploaded: !document.uploadRequired,
                    uploader: terminDocument.employeeID
                };

                pics.push(listElement);

                this.svcSA.getFileByDocumentID(document.documentID, DokumentModels.DokumentSource.SA_DBDokumente).then(res => {
                    if (res) {
                        const bild: ServiceAppModels.DokumentDBFile = res as ServiceAppModels.DokumentDBFile;
                        if (bild) {
                            var reader = new FileReader();
                            imagesLoaded.push(
                                new Promise<void>((resolve) => {
                                    reader.onload = (imageInput) => { // called once readAsDataURL is completed
                                        if (imageInput.target) {
                                            if (imageInput.target.readyState == FileReader.DONE) {
                                                images.push({
                                                    image: imageInput.target.result as string,
                                                    thumbImage: imageInput.target.result as string,
                                                    alt: document.fileName,
                                                    title: document.fileName
                                                });
                                                resolve();
                                            }
                                        }
                                    };
                                    reader.onerror = () => resolve();
                                    reader.readAsDataURL(bild.binary);
                                })
                            );
                        }
                    }
                });
            }
        });

        // Via Browser Indexed-DB Bilder ermitteln
        this.terminIndexedDBPictures = this.svcSA.getBilderByServiceID(this.currTermin!.serviceID).sort((a, b) => a.createdDate < b.createdDate && 1 || -1);
        this.terminIndexedDBPictures.forEach(terminPicture => {
            let kundenAdresse = this.svcSA.getAuftragsAdresse(this.currTermin!.objectID, GlobalModels.AdressTypes.Kunde);
            let kontaktAdresse = this.svcSA.getAuftragsKontaktAdresse(this.currTermin!.objectID, GlobalModels.AdressTypes.Kunde);

            let blobBild = this.dokuData.getImageFromIndexedDB(terminPicture.documentID, terminPicture.fileName);

            if (blobBild.size > 0) {
                var reader = new FileReader();
                imagesLoaded.push(
                    new Promise<void>((resolve) => {
                        reader.onload = (imageInput) => { // called once readAsDataURL is completed
                            if (imageInput.target) {
                                if (imageInput.target.readyState == FileReader.DONE) {
                                    let bild: ServiceAppModels.ImageSliderElement = {
                                        image: imageInput.target.result as string,
                                        thumbImage: imageInput.target.result as string,
                                        alt: terminPicture.fileName,
                                        title: terminPicture.fileName
                                    };
                                    images.push(bild);
                                    resolve();
                                }
                            }
                        };
                        reader.onerror = () => resolve();
                        reader.readAsDataURL(blobBild);
                    })
                );

            }

            const user = this.userAuthService.getCurrentAuthenticatedUser()!;

            let listElement: ServiceAppModels.TerminBildListElement = {
                imageFile: 'photo.png',
                creator: user.firstName + ' ' + user.lastName,
                id: terminPicture.documentID,
                documentName: terminPicture.fileName,
                description: terminPicture.description,
                datum: terminPicture.createdDate,
                formattedDate: this._datumFormatPipe.transform(terminPicture.createdDate),
                firstName: kundenAdresse?.firstName,
                lastName: kundenAdresse?.lastName,
                ansprechVorname: kontaktAdresse?.firstName,
                ansprechName: kontaktAdresse?.lastName,
                dokumentQuelle: DokumentModels.DokumentSource.SA_DBBilder,
                uploaded: terminPicture.uploaded,
                uploader: user.employeeID
            };
            pics.push(listElement);
        });
        Promise.all(imagesLoaded).then(() => this.imageObject.next(images));
        this.terminBilder.next(pics);
    }
}
